import { bugtracker } from '@99designs/design-services-common';

export class PrimaryCTAUrlBuilder {
    private urlObj: URL;

    constructor(redirectUrl: string) {
        try {
            this.urlObj = new URL(redirectUrl, 'https://www.vistaprint.com');
        } catch (error) {
            bugtracker.notify(
                new Error(`${error instanceof Error ? error.message : String(error)}`),
                (event) => {
                    event.addMetadata('debug info', {
                        redirectUrl,
                    });
                }
            );
            throw error;
        }
    }

    withPrintMpvId(printMpvId?: string) {
        if (!printMpvId) return this;

        this.urlObj.searchParams.set('mpvId', printMpvId);
        return this;
    }

    withRequestType(requestType: string) {
        if (!requestType) return this;

        this.urlObj.searchParams.set('requestType', requestType);
        return this;
    }

    withWorkId(workId: string) {
        if (!workId) return this;

        this.urlObj.searchParams.set('workId', workId);
        return this;
    }

    withEsMpvId(mpvId: string) {
        if (!mpvId) return this;

        this.urlObj.searchParams.set('esmpvid', mpvId);
        return this;
    }

    withServiceSelectedOptions(options: string) {
        if (!options) return this;

        this.urlObj.searchParams.set('serviceSelectedOptions', options);
        return this;
    }

    get url(): string {
        return this.urlObj.pathname + this.urlObj.search + this.urlObj.hash;
    }
}
